import { seoProduct, product } from '@shopee_common/url/src/urls/product';

type Params = {
  shopId: number;
  itemId: number;
  seoName?: string;
  vItemId?: number;
  vShopId?: number;
  vModelId?: number;
  rModelId?: number;
};

export const productPage = (params: Params): string =>
  seoProduct.getUrl(params);

export const getProductPath = (params: Params) => {
  const urlCreator =
    params.seoName && typeof params.seoName === 'string' ? seoProduct : product;
  const { itemId, shopId, seoName, ...rest } = params;

  return {
    pathname: urlCreator.getUrl({ shopId, itemId, seoName }),
    search: urlCreator.formatParamsToQuery(rest) as any,
  };
};
